/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

// material-ui
import { Paper, Box, Typography, withStyles } from '@material-ui/core'
import TreeView from '@material-ui/lab/TreeView'
import TreeItem from '@material-ui/lab/TreeItem'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

// Data query function
import useArticlesByMonth from '../../data/useArticlesByMonth'

const styles = {
  root: {
    flexGrow: 1,
    maxWidth: 400
  },
}

/**
 * Function render articles by month and year in a tre views
 * @param classes
 * @param navigate
 * @returns {*}
 * @constructor
 */
function ArticlesTreeView({ classes, navigate }) {
  const articlesByMonthTree = useArticlesByMonth()

  return (
    <Box clone p={1}>
      <Paper elevation={1}>
        <Typography component="div" variant="caption" gutterBottom>
          Articles by months
        </Typography>
        <TreeView
          className={classes.root}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
        >
          {Object.keys(articlesByMonthTree).map((month, index) => {
            const nodes = articlesByMonthTree[month]

            return (
              <TreeItem key={index} nodeId={month} label={month}>
                {nodes.map(({ title, slug }) => {
                  return <TreeItem key={slug} nodeId={slug} label={title} onClick={() => navigate(slug)} />
                })}
              </TreeItem>
            )
          })}
        </TreeView>
      </Paper>
    </Box>
  )
}

export default withStyles(styles)(ArticlesTreeView)
